import { DELETE_CATEGORIES, GET_CATEGORIES, UPDATE_CATEGORY } from "../../@jumbo/constants/ActionTypes";

const INIT_STATE = {
    dataCategories: [],
    isLoadedCategory: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CATEGORIES: {
            return {
                ...state,
                dataCategories: action.payload,
                isLoadedCategory: true
            };
        }
        case DELETE_CATEGORIES: {
            return {
                ...state
            }
        }
        case UPDATE_CATEGORY: {
            return {
                ...state
            }
        }
        default:
            return state;
    }
};
